import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import ImageWithTooltip from "../Common/ImageWithTooltip";
import IconWithTooltip from "../Common/IconWithTooltip";
import useGetHeightPage from "../../Hooks/useGetHeightPage";

const ElementWithGenericTrigger = ({
  elementType = "button", 
  elementValue,
  elementDescription,
  fnInString, 
  elementClassName, 
  elementID = 0
}) => {
  const [urlEmbedModal, setUrlEmbedModal] = useState(null);
  const [modalConfig, setModalConfig] = useState([{}]);
  const [openModalVisualization, setOpenModalVisualization] = useState(false);
  const [iframeHeight, setIframeHeight] = useState(300);

  const genericTrigger = (type, transaction_id, params, config) => {
    switch (type) {
      case "Modal":
        setUrlEmbedModal(window.location.origin + `/${transaction_id}?modal=true&` + params);        
        if (config?.length) setModalConfig(config);
        setOpenModalVisualization(true);
        break;
      case "Blank":
        window.open(
          window.location.origin +
            `/${transaction_id}${params ? `?${params}` : ""}`,
          "_blank"
        );
        break;
      case "Redirect":
        window.open(
          window.location.origin +
            `/${transaction_id}${params ? `?${params}` : ""}`,
          "_self"
        );
        break;
      default:
        console.warn(`Tipo ${type} de trigger desconhecido`);
    }
  };

  const renderElement = (type) => {
    switch (type) {
      case "button":
        return (
          <button id={elementID} key={elementID} className={`${elementClassName || 'btn btn-primary'}`} onClick={() => eval(fnInString)}>
            {elementValue}
          </button>
        );
      case "image-tooltip":
        return (
          <ImageWithTooltip
            id={elementID}
            image={elementValue}
            describe={elementDescription}
            className={elementClassName}
            fn={() => eval(fnInString)}
          />
        );
      case "icon-tooltip":
        return (
          <IconWithTooltip
            id={elementID}
            icon={elementValue}
            describe={elementDescription}
            fn={() => eval(fnInString) }
          />
        );
      case "badge":
        return (
          <span id={elementID} onClick={() => eval(fnInString) } className={`badge ${elementClassName || 'rounded-pill bg-primary'}`}>{elementValue}</span>
        );
      case "text":
        return (
          <span id={elementID} onClick={() => eval(fnInString) } className={elementClassName}>{elementValue}</span>
        );
      default:
        return <span>elemento não definido</span>;
    }
  }

  useGetHeightPage()

  useEffect(() => {
      const messageListener = (event) => {
        if(event.data.iframeHeight) {
          setIframeHeight(event.data.iframeHeight);
        }
      };
      window.addEventListener("message", messageListener);
      return () => {
        window.removeEventListener("message", messageListener);
      };
    }, []);

  return (
    <>
      {renderElement(elementType)}

      <Modal
        className={`modal-dinamic-table-simple type-${modalConfig[0].type}`}
        isOpen={openModalVisualization}
        style={modalConfig.length ? { width: modalConfig[0].width } : {}}
        toggle={() => {
          setOpenModalVisualization(!openModalVisualization);
        }}
      >
        <div>
          <div className="modal-header d-flex align-items-center justify-content-between">
            <h5
              className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
              id="myModalLabel"
            >
              {modalConfig[0]?.titleModal || "Não mapeado"}
            </h5>
            <button
              type="button"
              onClick={() => {
                setOpenModalVisualization(!openModalVisualization);
              }}
              className="btn border-0 p-0"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="fas fa-times font-size-24 text-gray-secundary"></i>
            </button>
          </div>
          <div
              className="modal-body"
              style={
                modalConfig.length ? { height: `${iframeHeight+ 60}px` } : {}
              }
            >
              {urlEmbedModal && (
                <iframe
                  id="embed-view-in-modal"
                  width="100%"
                  height={`${iframeHeight + 20}px`}
                  src={urlEmbedModal}
                  frameborder="0"
                  allowFullScreen="true"
                ></iframe>
              )}
            </div>
        </div>
      </Modal>
    </>
  );
};

export default ElementWithGenericTrigger;